export default __webpack_public_path__ + "cc1c90bbb28e5cccf590ee64f084071e.svg";